export default __webpack_public_path__ + "static/repairBlock-5b0b91caddb536df02e92abeaa8f8332.png";